/**
 * D2R admin UI (nav link, admin pages) — only these emails see Admin.
 * Must match server/constants/d2rAdminEmails.js
 */
export const D2R_ADMIN_EMAILS = Object.freeze(['adiman@tamu.edu', 'drew.casey@tamu.edu']);

const adminSet = new Set(D2R_ADMIN_EMAILS.map((e) => e.toLowerCase()));

export const isD2RAdminEmail = (email) => {
  if (!email || typeof email !== 'string') return false;
  return adminSet.has(email.trim().toLowerCase());
};
